import { render } from "./ZuLiZhiXingPage.vue?vue&type=template&id=8af5bbd0&scoped=true"
import script from "./ZuLiZhiXingPage.vue?vue&type=script&lang=js"
export * from "./ZuLiZhiXingPage.vue?vue&type=script&lang=js"

import "./ZuLiZhiXingPage.vue?vue&type=style&index=0&id=8af5bbd0&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af5bbd0"]])

export default __exports__